const MAIN_IMG =
  "https://readdy.ai/api/search-image?query=wide%20backstage%20scene%20with%20rows%20of%20warm%20vanity%20lights%20and%20silhouettes%20of%20crew%20moving%2C%20stage%20curtain%20edge%2C%20cinematic%20documentary%20photography%2C%20warm%20amber%20and%20deep%20shadow%2C%20film%20grain%2C%20editorial%20mood&width=1000&height=700&seq=backstage-main-x1&orientation=landscape";
const SUB_IMG =
  "https://readdy.ai/api/search-image?query=clapperboard%20and%20director%20chair%20detail%20in%20dim%20warm%20studio%2C%20film%20set%20atmosphere%2C%20editorial%20documentary%20close%20up%2C%20film%20grain%2C%20warm%20tones&width=500&height=360&seq=backstage-sub-x1&orientation=portrait";

export default function BackstagePeek() {
  return (
    <section id="backstage" className="bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid items-center gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3">
              <span className="flex h-9 items-center gap-1.5 rounded-md bg-accent-500 px-3 text-sm font-bold text-background-50">
                <i className="ri-vidicon-line" aria-hidden="true"></i>
                镜头之外
              </span>
              <span className="text-xs font-semibold tracking-[0.3em] text-foreground-500">
                BEHIND THE SCENES
              </span>
            </div>

            <h3 className="mt-5 font-heading text-3xl font-black leading-snug text-foreground-950 md:text-4xl md:leading-[1.2]">
              切掉摄像机后，
              <br className="hidden md:block" />
              成人吃瓜幕后闹剧才刚开场
            </h3>
            <p className="mt-5 max-w-xl font-heading text-base leading-relaxed text-foreground-700 md:text-lg">
              现场一片其乐融融，后台却在为一句没剪进正片的台词复盘到凌晨。我们蹲在灯架与化妆台之间，把成人吃瓜幕后闹剧最真实的分钟，一帧一帧记下来。
            </p>

            <div className="mt-8 grid gap-4 sm:grid-cols-3">
              {[
                { icon: "ri-time-line", big: "03:20", label: "深夜开机花絮" },
                { icon: "ri-discuss-line", big: "4 组", label: "后台对稿口径" },
                { icon: "ri-user-heart-line", big: "11 人", label: "剧组匿名信源" },
              ].map((c) => (
                <div
                  key={c.label}
                  className="rounded-lg border border-foreground-200/60 bg-background-50 p-4 text-center"
                >
                  <i className={`${c.icon} text-lg text-primary-600`} aria-hidden="true"></i>
                  <p className="mt-2 font-heading text-2xl font-black text-foreground-950">{c.big}</p>
                  <p className="mt-1 text-xs text-foreground-500">{c.label}</p>
                </div>
              ))}
            </div>

            <a
              href="#timeline"
              className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
            >
              看完整幕后记录
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
          </div>

          <div className="lg:col-span-5">
            <div className="grid grid-cols-3 gap-4">
              <div className="col-span-2 overflow-hidden rounded-lg border border-foreground-200/60">
                <img
                  src={MAIN_IMG}
                  alt="成人吃瓜幕后闹剧探班记录"
                  title="成人吃瓜幕后闹剧"
                  className="h-80 w-full object-cover object-top md:h-[420px]"
                />
              </div>
              <div className="overflow-hidden rounded-lg border border-foreground-200/60">
                <img
                  src={SUB_IMG}
                  alt="成人吃瓜幕后闹剧道具细节"
                  title="成人吃瓜幕后闹剧"
                  className="h-40 w-full object-cover object-top md:h-[200px]"
                />
              </div>
              <div className="col-span-3 flex items-center justify-between rounded-lg border border-foreground-200/60 bg-foreground-950 px-5 py-4 text-background-100">
                <p className="text-sm leading-relaxed">
                  <strong className="text-accent-400">「机器关掉的那一刻，才是真正的真人秀。」</strong>
                </p>
                <span className="shrink-0 whitespace-nowrap text-xs text-background-100/60">—— 幕后老友记</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}